
import {
  Component, Mixins,
} from 'vue-property-decorator';
import {
  Lead, LeadType, Task, ConfirmDialogOptions,
} from '@/types';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class TaskSuperActions extends Mixins(UtilsMixin) {
  confirmDialog = false

  // Opzioni del dialog di conferma per la conversione da effettuare
  confirmOptions: ConfirmDialogOptions = {
    title: '',
    text: '',
    question: '',
    yesText: '',
    noText: '',
  }

  // Dettagli sull'azione da eseguire eventualmente
  action = ''

  // La Lead selezionata memorizzata tramite Vuex
  get selectedLead(): Lead | null {
    return this.$store.getters.currentLead;
  }

  // Il Task selezionato memorizzato tramite Vuex
  get selectedTask(): Task | null {
    return this.$store.getters.selectedTask;
  }

  // Sto caricando il Task
  get loading(): boolean {
    return this.$store.getters.isTaskLoading;
  }

  // Sto aggiornando il Task
  get updating(): boolean {
    return this.$store.getters.isTaskUpdating;
  }

  get leadType(): LeadType | null {
    return this.selectedLead?.type ?? null;
  }

  get taskVersion(): number | null {
    return this.selectedTask?.version ?? 1;
  }

  get taskName(): string | null {
    return this.selectedTask?.name ?? null;
  }

  get canForceComplete(): boolean {
    return (this.selectedTask
      && this.selectedTask.status === null
      && this.hasPermission('task.status.can_force_complete')) ?? false;
  }

  get canConvertTaskA(): boolean {
    return (this.taskVersion === 1
      && this.taskName === 'A'
      && this.leadType === 'installatore-figlia'
      && this.hasPermission('taska.upgrade')) ?? false;
  }

  get canConvertTaskR(): boolean {
    return (this.taskVersion === 1
      && this.taskName === 'R'
      && this.leadType === 'elettrica-figlia'
      && this.hasPermission('taskr.upgrade')) ?? false;
  }

  get isVisible(): boolean {
    return this.canForceComplete || this.canConvertTaskA || this.canConvertTaskR;
  }

  onConfirm() {
    console.log(`${this.constructor.name}: onConfirm()`); // eslint-disable-line no-console

    this.$emit('action', this.action);
  }

  onConvertTaskA() {
    console.log(`${this.constructor.name}: onConvertTaskA()`); // eslint-disable-line no-console

    // Prepara i dati per l'eventuale conversione del task
    this.action = 'taska.upgrade_to_v2';

    // Prepara i testi per il dialog di conferma
    this.$set(this.confirmOptions, 'title', 'Vuoi procedere con la conversione del task?');
    this.$set(this.confirmOptions, 'text', [
      'Proseguendo, il task verrà aggiornato alla nuova versione (v2).',
      'La versione 2 dei task A supporta personalizzazioni specifiche che variano in base alla categoria assegnata alla lead.',
    ]);
    this.$set(this.confirmOptions, 'question', 'Vuoi procedere?');
    this.$set(this.confirmOptions, 'yesText', 'Sì, convertilo');
    this.$set(this.confirmOptions, 'noText', 'No, lascialo com\'è');

    // Apre il dialog di conferma
    this.confirmDialog = true;
  }

  onConvertTaskR() {
    console.log(`${this.constructor.name}: onConvertTaskR()`); // eslint-disable-line no-console

    // Prepara i dati per l'eventuale conversione del task
    this.action = 'taskr.upgrade_to_v2';

    // Prepara i testi per il dialog di conferma
    this.$set(this.confirmOptions, 'title', 'Vuoi procedere con la conversione del task?');
    this.$set(this.confirmOptions, 'text', [
      'Proseguendo, il task verrà aggiornato alla nuova versione (v2). Queste le novità:',
      '- Gli allegati di tipo DICO (Elettrica) e Visura verranno uniti in un\'unica tipologia di allegato (DICO e Visura camerale).',
      '- L\'allegato di tipo Autotest o Test report, è stato suddiviso in 3 campi separati (Inverter, Batteria lato AC, SPI esterna).',
    ]);
    this.$set(this.confirmOptions, 'question', 'Vuoi procedere?');
    this.$set(this.confirmOptions, 'yesText', 'Sì, convertilo');
    this.$set(this.confirmOptions, 'noText', 'No, lascialo com\'è');

    // Apre il dialog di conferma
    this.confirmDialog = true;
  }

  onForceComplete() {
    console.log(`${this.constructor.name}: onForceComplete()`); // eslint-disable-line no-console

    // Prepara i dati per l'eventuale forzatura del completamento del task
    this.action = 'force-complete';

    // Prepara i testi per il dialog di conferma
    this.$set(this.confirmOptions, 'title', 'Vuoi forzare il completamento del task?');
    this.$set(this.confirmOptions, 'text', 'Stai forzando il completamento di questo task.');
    this.$set(this.confirmOptions, 'question', 'Vuoi procedere?');
    this.$set(this.confirmOptions, 'yesText', 'Sì, completalo');
    this.$set(this.confirmOptions, 'noText', 'No, lascialo com\'è');

    // Apre il dialog di conferma
    this.confirmDialog = true;
  }
}
